import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Fade } from '@mui/material';
import { X } from 'lucide-react';
import React, { ReactNode } from 'react';
import { IconButton as CustomIconButton } from '@/components/Button/IconButton';
import './BaseDialog.css';

interface BaseDialogProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	children: ReactNode;
	actions?: ReactNode;
	withCloseIcon?: boolean;
	maxWidth?: string;
}

export const BaseDialog: React.FC<BaseDialogProps> = ({
	open,
	onClose,
	title,
	children,
	actions,
	withCloseIcon = true,
	maxWidth,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			slots={{ transition: Fade }}
			slotProps={{
				paper: {
					className: 'dialog-paper',
					sx: maxWidth
						? {
								maxWidth: `${maxWidth} !important`,
								width: `${maxWidth} !important`,
							}
						: undefined,
				},
				backdrop: { className: 'dialog-backdrop' },
				transition: { timeout: 300 },
			}}
		>
			{title && (
				<DialogTitle className="dialog-title">
					<Box className="dialog-title-box">
						<span className="dialog-title-text">{title}</span>
						{withCloseIcon && (
							<CustomIconButton
								variant="secondary"
								size="small"
								icon={<X size={20} />}
								onClick={onClose}
								aria-label="close"
								className="dialog-close-button"
							/>
						)}
					</Box>
				</DialogTitle>
			)}
			<DialogContent className="dialog-content">{children}</DialogContent>
			{actions && <DialogActions className="dialog-actions">{actions}</DialogActions>}
		</Dialog>
	);
};
